import React, { useState } from "react";
import PropTypes from "prop-types";
import { kpiReport, buttonName } from "../../../locales/en";
import { countries, timePeriods } from "../../../utils/data/data";
import KPIReportDownloadModal from "../../../components/modals/KPIReportDownloadModal";
import styles from "./../../../assets/scss/custom.module.scss";
import ".././reportStyle.scss";
import {
  MONTH,
  QUARTER,
  YEAR,
  WEEK
} from "../../../utils/constants/appConstants";
import {
  getAllViewType,
  getYears_periods
} from "../../../utils/getDropdownOptions";

const MonthlyKpiReportFilter = (props) => {
  const { values, setValues, loading } = props;
  const [addReportDownload, setAddReportDownload] = useState(false);
  const toggleReportDownload = () => {
    setAddReportDownload(!addReportDownload);
  };

  // viewType=====
  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValues = { ...values, [name]: value };

    // handle viewType special case
    if (name === "viewType") {
      const lowerValue = value.toLowerCase();
      newValues[name] = lowerValue;

      if (lowerValue === MONTH.toLowerCase()) {
        newValues.period = 12;
      } else if (lowerValue === QUARTER.toLowerCase()) {
        newValues.period = 4;
      } else if (lowerValue === YEAR.toLowerCase()) {
        newValues.period = "";
      } else if (lowerValue === WEEK.toLowerCase()) {
        newValues.period = 4;
      }
    } else {
      newValues[name] = value;
    }

    setValues(newValues);
  };

  return (
    <>
      <div className="filter d-flex align-self-center main-filter-bar flex-wrap">
        <div className="d-flex align-items-center mb-1 mt-1">
          <label htmlFor="view" className={`${styles.selectStatusLabel}`}>
            {kpiReport?.filter.viewTye}
          </label>
          <select
            name="viewType"
            className={`${styles.selectShowStatus} pe-5`}
            onChange={handleChange}
            value={values.viewType}
            id="view"
            disabled={loading}
          >
            {getAllViewType().map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="d-flex filter_download align-items-center mb-1 mt-1">
        <div className="d-flex">
          <label
            htmlFor="Status-sort"
            className={`${styles.selectStatusLabel} d-flex align-self-center `}
          >
            {kpiReport?.filter.period}
          </label>
          <select
            name="period"
            className={`${styles.selectShowStatus}`}
            value={values.period}
            onChange={handleChange}
            disabled={loading}
          >
            {values.viewType === YEAR ? (
              <>
                {getYears_periods.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.label}
                  </option>
                ))}
              </>
            ) : (
              <>
                {timePeriods.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.name}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
      </div>

      <div className="d-flex filter_download align-items-center justify-content-between mb-1 mt-1">
        <div className="d-flex">
          <label
            htmlFor="Status-sort"
            className={`${styles.selectStatusLabel} d-flex align-self-center `}
          >
            {kpiReport?.filter.selectCountry}
          </label>
          <select
            name="countrySelect"
            className={`${styles.selectShowStatus}`}
            onChange={handleChange}
            value={values.countrySelect}
            disabled={loading}
          >
            {countries.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="filter_download align-items-center col-12 text-end mb-1 mt-1">
        <button
          className="btn btn-primary ms-3"
          onClick={toggleReportDownload}
          disabled={loading}
        >
          {buttonName?.download}
        </button>
      </div>

      <KPIReportDownloadModal
        isOpen={addReportDownload}
        toggle={toggleReportDownload}
      />
    </>
  );
};

MonthlyKpiReportFilter.propTypes = {
  values: PropTypes.object,
  setValues: PropTypes.func,
  loading: PropTypes.bool
};
export default MonthlyKpiReportFilter;
